/**
 * Utility to remove all sales vehicles from Firestore
 * This can be called from the browser console or imported in a component
 */

import { vehiclesService } from '../services/firestoreService';
import { auth, db } from '../firebase/config';
import { collection, query, where, getDocs, writeBatch } from 'firebase/firestore';

/**
 * Remove all sales vehicles (status === 'Sales')
 */
export const removeAllSalesVehicles = async () => {
  try {
    const isAuthenticated = auth.currentUser !== null;
    
    if (!isAuthenticated) {
      throw new Error('You must be logged in to remove sales vehicles');
    }
    
    let deletedCount = 0;
    
    // Delete from Firestore using query to filter by status
    console.log('🗑️  Deleting all sales vehicles from Firestore...');
    
    try {
        const vehiclesRef = collection(db, 'vehicles');
        const q = query(vehiclesRef, where('status', '==', 'Sales'));
        const snapshot = await getDocs(q);
        
        // Firestore batch limit is 500, so we need to process in batches
        const batchSize = 500;
        const docs = snapshot.docs;
        
        for (let i = 0; i < docs.length; i += batchSize) {
          const batch = writeBatch(db);
          const batchDocs = docs.slice(i, i + batchSize);
          
          batchDocs.forEach((docSnapshot) => {
            batch.delete(docSnapshot.ref);
          });
          
          await batch.commit();
          deletedCount += batchDocs.length;
        }
        
        console.log(`✅ Deleted ${deletedCount} sales vehicles from Firestore`);
      } catch (error) {
        console.error('Error deleting sales vehicles from Firestore:', error);
        // If query fails (no index), fall back to client-side filtering
        console.log('⚠️  Falling back to client-side filtering...');
        const allVehicles = await vehiclesService.getAll();
        const salesVehicles = allVehicles.filter(v => v.status === 'Sales');
        
        for (const vehicle of salesVehicles) {
          await vehiclesService.delete(vehicle.id);
          deletedCount++;
        }
        console.log(`✅ Deleted ${deletedCount} sales vehicles from Firestore (fallback method)`);
      }
    
    console.log(`\n✅ Total sales vehicles removed: ${deletedCount}`);
    
    // Reload the page to see changes
    if (typeof window !== 'undefined') {
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
    
    return { success: true, deleted: deletedCount };
  } catch (error) {
    console.error('❌ Error removing sales vehicles:', error);
    throw error;
  }
};

// Make it available globally for easy console access
if (typeof window !== 'undefined') {
  window.removeAllSalesVehicles = removeAllSalesVehicles;
}

